export default "__VITE_ASSET__$eRhUDk2__"